import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Inventory} from '../model/invantory.model';
import {AppConfig} from '../shared/common/app.config';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  constructor(private http: HttpClient, private appConfig: AppConfig) { }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/inventory/';
  smsbaseUrl: string = this.appConfig.getConfig('BASE_URL') + 'api/sms/';

  saveInventory(invantory: Inventory) {
    return this.http.post<Inventory>(this.baseUrl + 'saveCardInventory/',invantory);
  }

  getLastInventory() {
    return this.http.get<Inventory>(this.baseUrl + 'getLastInventoryDetails/');
  }

  getCarCountByStatus() {
    return this.http.get(this.baseUrl + 'getInventoryCount/');
  }

  sendReOrderAlertSMS(){
    return this.http.get(this.smsbaseUrl + 'sendAlertSMS/');
  }



}
